import React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import cn from './cn';

/**
 * Radix Tabs, styled as the "tab track" the design handoff specifies: a filled track with
 * the active tab raised out of it, rather than an underline.
 *
 * Radix owns the roving-tabindex keyboard behaviour (arrow keys move between tabs, Home
 * and End jump to the ends) and the `aria-controls` wiring, which the hand-built status
 * filters in the list screens do not have.
 */
export const Tabs = TabsPrimitive.Root;

export const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'tw-inline-flex tw-items-center tw-gap-0.5 tw-rounded-card tw-bg-fill tw-p-0.5',
      className
    )}
    {...props}
  />
));
TabsList.displayName = 'TabsList';

export const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap',
      'tw-rounded-control tw-border-0 tw-bg-transparent tw-px-3 tw-py-1',
      'tw-font-sans tw-text-body tw-text-muted tw-cursor-pointer',
      'tw-transition-colors tw-duration-150 hover:tw-text-ink',
      'data-[state=active]:tw-bg-white data-[state=active]:tw-text-ink',
      'data-[state=active]:tw-font-bold data-[state=active]:tw-shadow-sm',
      'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-brand-focus',
      'disabled:tw-opacity-50 disabled:tw-cursor-not-allowed',
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = 'TabsTrigger';

export const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn('tw-mt-3 focus-visible:tw-outline-none', className)}
    {...props}
  />
));
TabsContent.displayName = 'TabsContent';

export default Tabs;
